"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  aggregationType: 'SUM',
  valueType: 'NUMBER'
};
exports.default = _default;
//# sourceMappingURL=dataElement.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/d2/model/config/model-defaults/dataElement.js
// module id = 1232
// module chunks = 0